const DEFAULT_STATE = {
    total_income: 0,
    total_expense: 0,
    money_flow: 0,
    income_objects: [],
    expense_objects: {},
    page: "main"
}

// export default DEFAULT_STATE
export default DEFAULT_STATE

// Schema

// income_objects: [{
//     id:
//     source:
//     amount;
// },]

// expense_objects: {
//     category: {
//         [
//            {
//                id:
//                item:
//                amount:
//             },
//         ]
//     },
// }